import React from "react";
import Modal from "react-modal";
import { sanitizeHtml } from "../../../../shared/sanitize";
import { ReactComponent as Error } from "../../../../assets/icons/error.svg";
import { errorMessages } from "../../../../constants/errorMessages.constants";
import ErrorText from "../../../common/ErrorText/ErrorText";

const modalContentClassName =
  "fixed left-1/2 top-1/2 z-[5] -translate-x-1/2 -translate-y-1/2 outline-none " +
  "!w-[37%] max-[850px]:!w-[70%] rounded-[30px] bg-white";

const overlayClassName = "fixed inset-0 z-[4]";

const secondTextClassName =
  "px-0 py-2.5 text-base leading-5 text-[#646464] [&_a]:text-base [&_a]:leading-[19px] [&_a]:text-[#646464] [&_a:hover]:text-[#8c8c8c] [&_div]:max-h-[40vh] [&_div]:overflow-y-auto [&_div]:text-base [&_div]:leading-[19px]";

const RenewalPafAlertModal = ({
  closeConfirm,
  confirmPrescriptionAuthorisationForm,
  errorMessage,
  validateVerify,
  handleChangeValidPassword,
  errorMessageFromServer,
}) => {
  return (
    <Modal
      isOpen={confirmPrescriptionAuthorisationForm}
      onRequestClose={closeConfirm}
      className={modalContentClassName}
      contentLabel="Renewal PAF alert"
      overlayClassName={overlayClassName}
      shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
    >
      <div className="grid min-h-[350px] p-[57px] text-center" data-testid="paf-renew-alert-modal">
        <div className="mb-2.5 flex justify-center">
          {errorMessage.type === "error" ? <Error /> : ""}
        </div>
        <div
          className={
            errorMessage.type === "error"
              ? "mb-2.5 text-[30px] font-bold leading-[37px] text-[#da291c]"
              : "text-[30px] font-bold leading-[37px] text-[#00567a]"
          }
          data-testid="paf-renew-alert-title"
        >
          {errorMessage.title === errorMessages.OUTDATED_DATE_BIRTH_TITLE
            ? "Continue with off-label use"
            : errorMessage.title}
        </div>
        <div
          className={secondTextClassName}
          data-testid="paf-renew-alert-description"
        >
          {errorMessage.description}
        </div>
        <div
          className={secondTextClassName}
          data-testid="paf-renew-alert-second-description"
          dangerouslySetInnerHTML={sanitizeHtml(errorMessage.secondDescription)}
        ></div>

        {errorMessage.modalState === 2 && errorMessage.hasSecondState && (
          <React.Fragment>
            <input
              type="password"
              placeholder="Password"
              className="h-10 w-full border-0 bg-transparent px-2.5 py-0 shadow-[inset_0_0_0_50px_#f8f8f8] outline-transparent"
              onChange={(e) => handleChangeValidPassword(e)}
              data-testid="paf-renew-alert-password-input"
            />
            <div
              className="min-h-10"
              data-testid="paf-renew-alert-server-errors"
            >
              {(errorMessageFromServer || []).map((item, index) => (
                <ErrorText key={index} item={item} />
              ))}
            </div>
          </React.Fragment>
        )}
      </div>
      <div
        className="mb-[45px] flex justify-center text-center"
        data-testid="paf-renew-alert-actions"
      >
        <button
          type="button"
          className="mr-6 cursor-pointer border-none bg-transparent text-base font-bold leading-[19px] text-[#646464] hover:text-[#646464c9]"
          onClick={closeConfirm}
          data-testid="paf-renew-alert-cancel-button"
        >
          Cancel
        </button>
        <button
          type="button"
          className={
            errorMessage.type === "error"
              ? "h-[46px] w-[159px] cursor-pointer rounded-full border-0 bg-[#da291c] text-lg font-bold leading-[22px] text-white hover:bg-[#d45454]"
              : "h-[46px] w-[159px] cursor-pointer rounded-full border-0 bg-[#00a03b] text-base font-bold leading-[19px] text-white"
          }
          onClick={validateVerify}
          data-testid="paf-renew-alert-submit-button"
        >
          {errorMessage.buttonText}
        </button>
      </div>
    </Modal>
  );
};
export default RenewalPafAlertModal;
